import { IGroupAttendeeResponse, ISpecialCodesResponse } from './interfaces/special-codes.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';
import { CacheExpiryForARIApi } from '../shared/constants/global.constants';
/**
 * @ignore
 */
declare const TCCommonService;
class SpecialCodes {
    async validateSpecialCode(hotelCode: number, codeType: string, codeValue: string, enableApiCaching: boolean = false,
        languageId: string, currencyCode?: string, tcShareLocation?: boolean, loyaltyTierId?: number) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_special_codes_' +
            hotelCode + '_' + codeType?.toLowerCase() + '_' + codeValue?.toLowerCase() + '_' + languageId?.toLowerCase() +
            '_' + loyaltyTierId;
        if (enableApiCaching) {
            const specialCodeFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({
                key: cacheKey, expiryTime: CacheExpiryForARIApi
            });
            if (specialCodeFromCache) {
                return specialCodeFromCache;
            }
        }

        try {
            const specialCodeResponse: Response = await ApiService.validateSpecialCode(hotelCode, codeType, codeValue,
                languageId, currencyCode, tcShareLocation, loyaltyTierId);
            const specialCodeObject: (ISpecialCodesResponse | IGroupAttendeeResponse) = await specialCodeResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: specialCodeObject });
                TCCommonService.CacheTrackingService
                    .setCacheTracking({ key: 'validateSpecialCode', value: cacheKey});
            }
            return specialCodeObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
    async validateGroupId(hotelCode: number, groupId: number, enableApiCaching: boolean = false,
        languageId: string, currencyCode?: string, tcShareLocation?: boolean, loyaltyTierId?: number) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_special_codes_' +
            hotelCode + '_' + 'group' + '_' + groupId?.toString() + '_' + languageId?.toLowerCase() +
            '_' + loyaltyTierId;
        if (enableApiCaching) {
            const specialCodeFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({
                key: cacheKey, expiryTime: CacheExpiryForARIApi
            });
            if (specialCodeFromCache) {
                return specialCodeFromCache;
            }
        }

        try {
            const specialCodeResponse: Response = await ApiService.validateGroupId(hotelCode, groupId,
                languageId, currencyCode, tcShareLocation, loyaltyTierId);
            const specialCodeObject: (ISpecialCodesResponse | IGroupAttendeeResponse) = await specialCodeResponse.json();
            if (enableApiCaching) {
                TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: specialCodeObject });
                TCCommonService.CacheTrackingService
                    .setCacheTracking({ key: 'validateGroupById', value: cacheKey });
            }
            return specialCodeObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }

}

export const SpecialCodesService = new SpecialCodes();
